var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "elevation": "0"
    }
  }, [_vm.title ? _c('v-card-title', {
    staticClass: "tit tit--sm primary--text pt-0 px-0"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _vm._e(), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_vm._t("default")], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }